/* eslint-disable react-hooks/exhaustive-deps */

import BigPic from 'icons/big-pic.svg';
import ListPic from 'icons/list-pic.svg';
import LocationIcon from 'icons/location.svg';
import Sx from 'icons/sx.svg';

import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react';
import { DropdownMenu } from 'react-vant';
import { cls } from 'reactutils';
import SearchCondtionDrawer from 'comps/h5/Search/components/SearchConditionDrawer';
import AreaPickerWithLevel from 'comps/AreaPickerWithLevel';
import { SORT_OPTS } from '../constants/mall-condition';
import { SearchConditionProps, Condition, AreaItem } from './types/MallCondition';

export default forwardRef(function MallCondition(
  {
    value,
    onChange,
    conditionList,
    changeListType,
    keyword,
    conditionTypeList,
    shopSysNo,
    listType,
  }: SearchConditionProps,
  ref,
) {
  const [showAreaPicker, setShowAreaPicker] = useState(false);
  const [selectAreas, setSelectAreas] = useState<Array<AreaItem>>([]);
  const [visible, setVisible] = useState(false);
  const [hasCondition, setHasCondition] = useState(false);
  const areaPickerRef = useRef(null);
  const sortsOptionsChanged = (v) => {
    let sorts = [];
    const selectedItem = v['sorts'];
    if (selectedItem === 0) {
      sorts = [];
    } else {
      const arr = selectedItem.split(':');
      sorts.push({ sortField: arr[0], orderBy: arr[1] });
    }
    onChange({ ...value, sorts });
  };

  const drawerChange = (v: Condition, list: any) => {
    checkCondition(v);
    onChange({ ...value, ...v }, list);
  };

  const checkCondition = (v: Condition) => {
    if (v.onlyShowAgreement) {
      setHasCondition(true);
    } else {
      setHasCondition(
        Object.entries(v)
          .filter((v) =>
            [
              'attributeNameList',
              'attributeValueList',
              'categorySysNoList',
              'brandSysNoList',
            ].includes(v[0]),
          )
          .some((v) => v[1]?.length > 0),
      );
    }
  };

  useImperativeHandle(ref, () => ({
    areaPicker: areaPickerRef.current,
    checkCondition,
  }));

  const areaName = useCallback(() => {
    const arr = selectAreas?.slice(-2);
    const str = arr.map((v) => v.name).join('/');
    return str;
  }, [selectAreas]);
  return (
    <>
      <div className={'filterBox'}>
        <div onClick={() => setShowAreaPicker(true)} ref={areaPickerRef as any}>
          {selectAreas.length > 0 && (
            <span className={cls('filterTxt')}>
              <LocationIcon className="location" />
              <span className="area-name">{areaName()}</span>
            </span>
          )}
        </div>
        <div className="sorts-options">
          <DropdownMenu defaultValue={{ sorts: 0 }} onChange={sortsOptionsChanged}>
            <DropdownMenu.Item name="sorts" options={SORT_OPTS} />
          </DropdownMenu>
        </div>
        <div>
          <span className="change-icon" onClick={changeListType}>
            {listType === 'card' ? <BigPic /> : <ListPic />}
          </span>
          <span
            onClick={() => setVisible(true)}
            className={cls('filterTxt', hasCondition && 'activeText filterSvg')}
          >
            筛选
            <Sx />
          </span>
        </div>
      </div>
      <AreaPickerWithLevel
        visible={showAreaPicker}
        onClose={() => setShowAreaPicker(false)}
        onChange={(val) => {
          setSelectAreas(val);
          setShowAreaPicker(false);
        }}
        onInit={(val) => {
          setSelectAreas(val);
          setShowAreaPicker(false);
        }}
        areaLevel={3}
      />
      {
        <SearchCondtionDrawer
          visible={visible}
          conditionList={conditionList}
          onChange={drawerChange}
          onClose={() => setVisible(false)}
          keyword={keyword}
          conditionTypeList={conditionTypeList}
          value={value}
          shopSysNo={shopSysNo}
          selectAreas={selectAreas}
        />
      }
      <style jsx>{`
        .area-name {
          display: inline-block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 130px;
          vertical-align: top;
        }
        .filterBox {
          height: 47px;
          display: flex;
          font-size: 14px;
          color: #333333;
          width: 100%;
          align-items: center;
          justify-content: space-around;
          background-color: #fff;
          box-shadow: 0 4px 7px -3px rgba(0, 0, 0, 0.13);
          position: relative;
          z-index: 1;
          flex-shrink: 0;
          border-top: 1px solid #f2f2f2;
          margin-bottom: 16px;
          overflow: hidden;
        }

        .filterIcon {
          margin-left: 5px;
          vertical-align: middle;
          margin-top: 2px;
          display: inline-block;
        }

        .change-icon {
          display: inline-block;
          border-left: 1px solid #e3e4e5;
          height: 14px;
          padding-left: 24px;
          vertical-align: middle;
          transform: translateX(-18px);
        }
        .change-icon :global(svg) {
          transform: translateY(-2px);
          width: 14px;
          height: 14px;
        }

        .filterTxt {
          display: inline-block;
          vertical-align: middle;
        }
        .filterTxt svg {
          margin-right: 3px;
        }

        .filterBox :global(.filterSvg svg) {
          margin-left: 2px;
          width: 12px;
          transform: translateY(1px);
        }

        .filterBox :global(.filterSvg svg path) {
          fill: var(--primaryColor);
        }

        .filterTxt.active {
          color: var(--primaryColor);
        }

        .filterBox :global(.location) {
          transform: translate(0px, 3px);
        }

        .activeText {
          color: var(--primaryColor);
        }

        .sorts-options {
          --rv-dropdown-menu-height: 47px;
          --rv-dropdown-menu-box-shadow: none;
          --rv-dropdown-menu-title-font-size: 14px;
          --rv-dropdown-menu-title-text-color: #333;
          --rv-dropdown-menu-title-active-text-color: var(--primaryColor);
          --rv-dropdown-menu-option-active-color: var(--primaryColor);
        }

        .sorts-options :global(.rv-cell::after) {
          display: none;
        }
      `}</style>
    </>
  );
});
